export default __webpack_public_path__ + "static/media/E_Contract.c781955b.jpg";